module.exports = __webpack_public_path__ + "static/media/bg_3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_3.png
// module id = 48
// module chunks = 0